"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBaiduLocationAccountApi = addBaiduLocationAccountApi;
exports.changeColorApi = changeColorApi;
exports.clearCacheApi = clearCacheApi;
exports.configCheckUnique = configCheckUnique;
exports.configDelete = configDelete;
exports.configGetUniq = configGetUniq;
exports.configInfo = configInfo;
exports.configList = configList;
exports.configSave = configSave;
exports.configSaveForm = configSaveForm;
exports.configSaveUniq = configSaveUniq;
exports.configUpdate = configUpdate;
exports.deleteBaiduLocationAccountApi = deleteBaiduLocationAccountApi;
exports.editBaiduLocationAccountApi = editBaiduLocationAccountApi;
exports.getAuthHostApi = getAuthHostApi;
exports.getBaiduLocationAccountListApi = getBaiduLocationAccountListApi;
exports.getBaiduLocationAccountsApi = getBaiduLocationAccountsApi;
exports.getCurrentBaiduLocationAccountApi = getCurrentBaiduLocationAccountApi;
exports.getHomeStyleApi = getHomeStyleApi;
exports.getMiniDownloadUrlApi = getMiniDownloadUrlApi;
exports.getSiteLogoApi = getSiteLogoApi;
exports.getTxMapKeyApi = getTxMapKeyApi;
exports.getUploadTypeApi = getUploadTypeApi;
exports.passAppInfoApi = passAppInfoApi;
exports.passAppSaveApi = passAppSaveApi;
exports.resetTodayStatsBaiduLocationAccountApi = resetTodayStatsBaiduLocationAccountApi;
exports.saveBaiduLocationAccountsApi = saveBaiduLocationAccountsApi;
exports.saveColorApi = saveColorApi;
exports.savehomeStyleApi = savehomeStyleApi;
exports.sendFeiShuNotifyApi = sendFeiShuNotifyApi;
exports.setCurrentBaiduLocationAccountApi = setCurrentBaiduLocationAccountApi;
exports.testBaiduLocationAccountApi = testBaiduLocationAccountApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function configCheckUnique(pram) {
  var data = {
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/system/config/check',
    method: 'GET',
    params: data
  });
}
function configDelete(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/config/delete',
    method: 'GET',
    params: data
  });
}
function configInfo(pram) {
  var data = {
    formId: pram.id
  };
  //return request({
  //url: '/admin/system/config/info',
  return (0, _requestMapi.default)({
    url: '/mapi/system/config/info',
    method: 'GET',
    params: data
  });
}
function configList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/config/list',
    method: 'GET',
    params: data
  });
}
function configSave(pram) {
  var data = {
    systemConfigRequest: {
      desc: pram.desc,
      groupId: pram.groupId,
      info: pram.info,
      name: pram.name,
      pid: pram.pid,
      status: pram.status,
      type: pram.type,
      value: pram.value // value 存储表单配置数据，其他的参数来自于父级数据 justForAPI
    }
  };
  return (0, _request.default)({
    url: '/admin/system/config/save',
    method: 'POST',
    params: data
  });
}
function configSaveForm(pram) {
  return (0, _request.default)({
    url: '/admin/system/config/save/form',
    method: 'POST',
    data: pram
  });
}
function configUpdate(pram) {
  var data = {
    id: pram.id,
    systemConfigRequest: pram.systemConfigRequest
  };
  return (0, _request.default)({
    url: '/admin/system/config/update',
    method: 'POST',
    params: data
  });
}
function configSaveUniq(pram) {
  var data = {
    key: pram.key,
    value: pram.value
  };
  return (0, _request.default)({
    url: '/admin/system/config/saveuniq',
    method: 'POST',
    params: data
  });
}
function configGetUniq(pram) {
  var data = {
    key: pram.key
  };
  return (0, _request.default)({
    url: '/admin/system/config/getuniq',
    method: 'GET',
    params: data
  });
}

/**
 * @description 获取管理端logo
 */
function getSiteLogoApi() {
  // return request({
  //   url: '/admin/system/config/get/site/logo',
  //   method: 'GET'
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/system/config/get/site/logo',
    method: 'GET'
  });
}

/**
 * @description 获取文件存储类型
 */
function getUploadTypeApi() {
  return (0, _requestMapi.default)({
    //url: '/admin/system/config/get/upload/type',
    url: '/mapi/system/config/get/upload/type',
    method: 'GET'
  });
}

/**
 * @description 获取小程序下载地址
 */
function getMiniDownloadUrlApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/mini/download/url',
    method: 'GET'
  });
}

/**
 * @description 获取腾讯地图key
 */
function getTxMapKeyApi() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/config/get/tx/map/key',
    method: 'GET'
  });
}

/**
 * @description 发送飞书机器人文本消息（AK耗尽通知）
 */
function sendFeiShuNotifyApi(content) {
  return (0, _request.default)({
    url: '/admin/feishu/send',
    method: 'POST',
    data: {
      content: content
    }
  });
}

/**
 * @description 获取移动端首页列表样式
 */
function getHomeStyleApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/home/page/list/style',
    method: 'GET'
  });
}

/**
 * @description 获取移动端首页列表样式
 */
function getAuthHostApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/auth/host',
    method: 'GET'
  });
}

/**
 * @description 清除config缓存
 */
function clearCacheApi() {
  return (0, _request.default)({
    url: '/admin/system/config/clear/cache',
    method: 'post'
  });
}

/**
 * @description 获取主题色
 */
function changeColorApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/change/color',
    method: 'get'
  });
}

/**
 * @description 保存主题色
 */
function saveColorApi(data) {
  return (0, _request.default)({
    url: '/admin/system/config/save/change/color',
    method: 'post',
    data: data
  });
}

/**
 * @description 保存移动端首页列表样式
 */
function savehomeStyleApi(data) {
  return (0, _request.default)({
    url: '/admin/system/config/save/home/page/list/style',
    method: 'post',
    data: data
  });
}

/**
 * @description 获取百度定位账号配置
 */
function getBaiduLocationAccountsApi() {
  return (0, _request.default)({
    url: '/admin/system/config/getuniq',
    method: 'get',
    params: {
      key: 'BAIDU_LOCATION_ACCOUNTS'
    }
  });
}

/**
 * @description 获取百度定位账号列表
 */
function getBaiduLocationAccountListApi(pram) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/list',
    method: 'get',
    params: pram
  });
}

/**
 * @description 添加百度定位账号
 */
function addBaiduLocationAccountApi(data) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/add',
    method: 'post',
    data: data
  });
}

/**
 * @description 编辑百度定位账号
 */
function editBaiduLocationAccountApi(data) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 删除百度定位账号
 */
function deleteBaiduLocationAccountApi(id) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/delete/' + id,
    method: 'delete'
  });
}

/**
 * @description 测试百度定位账号
 */
function testBaiduLocationAccountApi(id) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/test/' + id,
    method: 'post'
  });
}

/**
 * @description 设置当前使用的百度定位账号
 */
function setCurrentBaiduLocationAccountApi(id) {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/set-current/' + id,
    method: 'post'
  });
}

/**
 * @description 获取当前使用的百度定位账号
 */
function getCurrentBaiduLocationAccountApi() {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/current',
    method: 'get'
  });
}

/**
 * @description 重置今日统计数据
 */
function resetTodayStatsBaiduLocationAccountApi() {
  return (0, _request.default)({
    url: '/admin/system/baidu/location/account/reset-today-stats',
    method: 'post'
  });
}

/**
 * @description 保存百度定位账号配置（向后兼容）
 */
function saveBaiduLocationAccountsApi(data) {
  return (0, _request.default)({
    url: '/admin/system/config/saveuniq',
    method: 'post',
    params: {
      key: 'BAIDU_LOCATION_ACCOUNTS',
      value: data
    }
  });
}

/**
 * @description 一号通 应用保存
 */
function passAppSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/pass/appsave',
    method: 'post',
    data: data
  });
}

/**
 * @description 一号通 应用详情获取
 */
function passAppInfoApi() {
  return (0, _request.default)({
    url: '/admin/pass/appget',
    method: 'get'
  });
}